import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SliderInputValue } from '../models';
import { mapToSliderInputText } from '../services';

export interface StartingConstraintState {
    startingVoltageText: SliderInputValue;
    acText: string;
    awText: string;
}

const initialState: StartingConstraintState = {
    startingVoltageText: mapToSliderInputText(100),
    acText: '',
    awText: ''
};

export const startingConstraintSlice = createSlice({
    name: 'startingConstraint',
    initialState,
    reducers: {
        setStartingVoltageText: (state: StartingConstraintState, action: PayloadAction<Partial<SliderInputValue>>) => {
            state.startingVoltageText = { ...state.startingVoltageText, ...action.payload };
        },
        setAcText: (state: StartingConstraintState, action: PayloadAction<string>) => {
            state.acText = action.payload;
        },
        setAwText: (state: StartingConstraintState, action: PayloadAction<string>) => {
            state.awText = action.payload;
        }
    }
});

export const { setStartingVoltageText, setAcText, setAwText } = startingConstraintSlice.actions;
export const startingConstraintReducer = startingConstraintSlice.reducer;
